import script from "./PamiaWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./PamiaWidget.vue?vue&type=script&setup=true&lang=ts"

import "./PamiaWidget.vue?vue&type=style&index=0&id=3dd3c970&scoped=true&lang=css"
import "./PamiaWidget.vue?vue&type=style&index=1&id=3dd3c970&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd3c970"]])

export default __exports__